// extracted by mini-css-extract-plugin
export default {"wrapper":"FileListPreview_wrapper__47RlP"};